import gql from 'graphql-tag';
const PUZZLING_LETTERS_ACTIVITY_FRAGMENT = gql `
  fragment PuzzlingLettersActivityFragment on PuzzlingLettersActivity {
    imageData: images {
      path
      rounds
      restrictToLetters
      image {
        img
        audio
      }
    }
    rounds {
      roundIndex
      steps {
        stepIndex
        answer
        audio
        image
        imageExtension
        imageNoExtension
      }
    }
  }
`;
export default PUZZLING_LETTERS_ACTIVITY_FRAGMENT;
